/** @format */

import { createAction, props } from '@ngrx/store';

export const setFulfillmentButtonsShipMode = createAction(
  '[Fulfillment Buttons] Set Ship Mode',
  props<{ shipMode: string }>(),
);

export const setNearbyStoresButtonEnabledFlag = createAction(
  '[Fulfillment Buttons] Set nearbyStoresButtonEnabled Flag',
  props<{ nearbyStoresButtonEnabled: boolean }>(),
);
